import { AlertCircle, TrendingUp, Award, ArrowDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const TangibleBenefits = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      title: t('tangibleBenefits.card1.title'),
      icon: AlertCircle,
      before: t('tangibleBenefits.card1.before'),
      after: t('tangibleBenefits.card1.after'),
      color: 'text-destructive',
      bgBefore: 'bg-destructive/5',
      bgAfter: 'bg-primary/5'
    },
    {
      title: t('tangibleBenefits.card2.title'),
      icon: TrendingUp,
      before: t('tangibleBenefits.card2.before'),
      after: t('tangibleBenefits.card2.after'),
      color: 'text-destructive',
      bgBefore: 'bg-destructive/5',
      bgAfter: 'bg-primary/5'
    },
    {
      title: t('tangibleBenefits.card3.title'),
      icon: Award,
      before: t('tangibleBenefits.card3.before'),
      after: t('tangibleBenefits.card3.after'),
      color: 'text-destructive',
      bgBefore: 'bg-destructive/5',
      bgAfter: 'bg-primary/5'
    }
  ];

  return (
    <div className="mb-16 animate-fade-in">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 bg-gradient-to-r from-foreground to-newsletter-primary bg-clip-text text-transparent">
          {t('tangibleBenefits.title')}
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="p-8 rounded-2xl border border-border/40 bg-background/60 backdrop-blur-sm hover:shadow-2xl hover:border-newsletter-primary/40 transition-all duration-700 group overflow-hidden relative"
          >
            <div className="flex items-center justify-center mb-6">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-newsletter-primary/80 via-newsletter-secondary/70 to-newsletter-primary/60 shadow-md flex items-center justify-center group-hover:shadow-xl group-hover:shadow-newsletter-primary/30 group-hover:scale-110 transition-all duration-700">
                <benefit.icon className="w-7 h-7 text-white group-hover:scale-110 transition-transform duration-700" />
              </div>
            </div>

            {/* Title */}
            <h3 className="text-lg font-semibold text-center mb-8 text-foreground group-hover:text-foreground transition-colors duration-700">
              {benefit.title}
            </h3>

            {/* Before - Desaturado e blur */}
            <div className="rounded-xl p-5 mb-4 bg-muted/20 border border-muted-foreground/10 opacity-65 blur-[0.3px] group-hover:opacity-30 group-hover:blur-[1px] transition-all duration-700 relative">
              <p className="text-xs font-medium text-muted-foreground/60 mb-2 uppercase tracking-wider">{t('tangibleBenefits.beforeLabel')}</p>
              <p className="text-sm text-muted-foreground/90 leading-relaxed">{benefit.before}</p>
            </div>

            {/* Arrow */}
            <div className="flex justify-center mb-4">
              <div className="w-8 h-8 rounded-full bg-gradient-to-b from-newsletter-primary/20 to-newsletter-secondary/20 flex items-center justify-center group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-newsletter-primary/30 transition-all duration-700">
                <ArrowDown className="w-4 h-4 text-newsletter-primary/70 group-hover:text-newsletter-primary group-hover:translate-y-0.5 transition-all duration-700" />
              </div>
            </div>

            {/* After - Vibrante e nítido */}
            <div className="rounded-xl p-5 bg-gradient-to-br from-newsletter-primary/10 via-newsletter-secondary/10 to-newsletter-primary/15 border border-newsletter-primary/30 shadow-md opacity-90 group-hover:opacity-100 group-hover:shadow-2xl group-hover:shadow-newsletter-primary/20 group-hover:border-newsletter-primary/50 group-hover:scale-[1.02] transition-all duration-700 relative">
              <p className="text-xs font-bold bg-gradient-to-r from-newsletter-primary to-newsletter-secondary bg-clip-text text-transparent mb-2 uppercase tracking-wider group-hover:scale-105 transition-transform duration-700 inline-block">{t('tangibleBenefits.afterLabel')}</p>
              <p className="text-sm text-foreground font-semibold leading-relaxed group-hover:text-foreground transition-colors duration-700">{benefit.after}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
